<template>
  <div class="about">
    <div class="section-background">
      <div class="container">
        <div class="hero">
          <div class="text">
            <p class="sub-title">
              Our latest news
            </p>
            <h1 class="title">
              News
            </h1>
            <br>
            <div class="row">
              <div class="col-sm-12 col-md-4">
                <a
                  href="release/cricket-serbia-joins-ludimos-family"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/cs-square.jpg"
                    alt="Cricket Serbia"
                  >
                  <div class="blog-body">
                    <h3>
                      Cricket Serbia join Ludimos Family
                    </h3>
                    <div class="date-author">
                      Ludimos team | March 10, 2021
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-sm-12 col-md-4">
                <a
                  href="release/cricket-argentina-joins-ludimos-family"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/ca-square.jpg"
                    alt="Cricket Argentina"
                  >
                  <div class="blog-body">
                    <h3>
                      Cricket Argentina join Ludimos Family
                    </h3>
                    <div class="date-author">
                      Ludimos team | December 12, 2020
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-sm-12 col-md-4">
                <a
                  href="release/ludimos-brings-in-german-cricket-academys-head-coach-as-its-advisor"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/abhijit-khan.jpg"
                    alt="CGTN africa"
                  >
                  <div class="blog-body">
                    <h3>
                      Ludimos brings in German Cricket Academy's Head coach as
                      its Advisor
                    </h3>
                    <div class="date-author">
                      Ludimos team | August 26, 2020
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-sm-12 col-md-4">
                <a
                  href="release/ludimos-goes-into-bat-with-northerns-on-cricket-development"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/titans.jpg"
                    alt="Titans"
                  >
                  <div class="blog-body">
                    <h3>
                      Ludimos goes into bat with northerns on cricket
                      development
                    </h3>
                    <div class="date-author">
                      Ludimos team | August 21, 2020
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-sm-12 col-md-4">
                <a
                  href="release/the-royal-dutch-cricket-association-partners-with-ludimos"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/kncb.png"
                    alt="CGTN africa"
                  >
                  <div class="blog-body">
                    <h3>
                      The Royal Dutch Cricket Association partners with Ludimos
                    </h3>
                    <div class="date-author">
                      Ludimos team | August 13, 2020
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-sm-12 col-md-4">
                <a
                  href="release/ludimos-technology-featured-in-cgtn"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/CGTN.jpg"
                    alt="CGTN africa"
                  >
                  <div class="blog-body">
                    <h3>
                      Ludimos technology is featured in CGTN
                    </h3>
                    <div class="date-author">
                      Ludimos team | July 16, 2020
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-sm-12 col-md-4">
                <a
                  href="release/sports-fever-360"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/SportsFever360.jpg"
                    alt="sports fever 360"
                  >
                  <div class="blog-body">
                    <h3>
                      SportsFever360 is our partner in the Middle East and
                      Pakistan
                    </h3>
                    <div class="date-author">
                      Ludimos team | July 3, 2020
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="visual">
            <div class="background">
              <img
                src="../assets/img/hero-background.svg"
                alt="background visual"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Press",
  metaInfo() {
    return {
      title: this.textEllipsis(`News`, 25),
    };
  },
};
</script>

<style lang="scss" scoped>
.blog-container {
  h3 {
    line-height: 30px;
    font-size: 18px;
  }
}
</style>
